import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'iposcen-ipos-help-manage-installation-profile',
  templateUrl: './ipos-help-manage-installation-profile.component.html',
  styleUrls: ['./ipos-help-manage-installation-profile.component.scss']
})
export class IposHelpManageInstallationProfileComponent implements OnInit {
  loginUserRole = sessionStorage.getItem('userRole');
  @Output() readonly sideNav = new EventEmitter();
  @ViewChild('manageTop') manageTop: ElementRef;
  constructor() { }

  ngOnInit(): void {
    setTimeout(_ => {
      this.manageTop.nativeElement.scrollIntoView();
    }, 0);
  }
  navigate(data) {
    this.sideNav.emit(['createCustomInstallation', '', data]);
  }
}
